import { render, staticRenderFns } from "./StaffReportTab.vue?vue&type=template&id=e397d22c&scoped=true&"
import script from "./StaffReportTab.vue?vue&type=script&lang=js&"
export * from "./StaffReportTab.vue?vue&type=script&lang=js&"
import style0 from "./StaffReportTab.vue?vue&type=style&index=0&id=e397d22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e397d22c",
  null
  
)

export default component.exports